// import { resultsToReferences } from '../app/utils'
import Api from '@disco/api/public-channels'
import { GROUPS_LOAD_SUCCESS } from '@disco/constants/ActionTypes'
import { loadBatch } from '@disco/state-management/actions/PlaylistTrackActions'
import get from 'lodash/get'
import type { Group, GroupId } from 'types/group'
import type { RootGroup } from 'types/shareable-channel'
import * as actions from './actions'
export const loadGroups = (
  groups: Group[],
): {
  groups: Array<Group>
  type: string
} => ({
  type: GROUPS_LOAD_SUCCESS,
  groups,
})
export const loadGroupContents =
  (group: Group | RootGroup): ((dispatch: any) => Promise<void>) =>
  async (dispatch: (...args: Array<any>) => any) => {
    try {
      dispatch(actions.loadGroupContents(group))
      const api = new Api()
      const response = await api.publicSearch(group)
      dispatch(actions.loadGroupContentsSuccess(group, response))
      dispatch(loadBatch(response.results))
    } catch (error) {
      dispatch(actions.loadGroupContentsFail(group, error))
      throw error
    }
  }
export const loadGroupContentsNext =
  (groupId: GroupId): ((dispatch: any, getState: any) => Promise<any>) =>
  async (
    dispatch: (...args: Array<any>) => any,
    getState: (...args: Array<any>) => any,
  ) => {
    const state = getState()
    const nextPage = get(state.view.byGroup, `${groupId}.nextPage`, null)
    if (!nextPage || state.view.loadingNextPage) return null

    try {
      dispatch(actions.loadGroupContentsNext(groupId))
      const api = new Api()
      const response = await api.getGroupContentsNextPage(groupId, nextPage)
      dispatch(actions.loadGroupContentsNextSuccess(groupId, response))
      return dispatch(loadBatch(response.results))
    } catch (error) {
      return dispatch(actions.loadGroupContentsNextFail(groupId, error))
    }
  }
export {
  loadGroupContentsSuccess,
  loadRootGroup,
  loadRootGroupZipUrls,
} from './actions'
